module.exports = __webpack_public_path__ + "static/media/bill_liu.904cebab.png";